import { createSlice, PayloadAction } from "@reduxjs/toolkit";

// Product item type
export interface FuelData {
  id: string;
  [key: string]: any;
}

// API response shape
interface FleetListResponse {
  fuel: FuelData[];
  total: number;
  page: number;
  totalPages: number;
}

// Slice state
interface PromoState {
  data: FleetListResponse | null;
  loading: boolean;
  error: string | null;
}

// Update payload
export interface FleetUpdatePayload {
  id: string;
  [key: string]: any;
}

const initialState: PromoState = {
  data: null,
  loading: false,
  error: null,
};

const fuelSlice = createSlice({
  name: "fuel",
  initialState,
  reducers: {
    // setFleetList(state, action: PayloadAction<FleetListResponse>) {
    //   state.data = action.payload;
    //   state.loading = false;
    //   state.error = null;
    // },
    setFuelList(state, action: PayloadAction<FleetListResponse>) {
      state.data = {
        ...action.payload,
        fuel: action.payload.fuel || [], // ensure array
      };
      state.loading = false;
      state.error = null;
    },

    setLoading(state, action: PayloadAction<boolean>) {
      state.loading = action.payload;
    },

    setError(state, action: PayloadAction<string | null>) {
      state.error = action.payload;
    },
  },
});

export const { setFuelList, setLoading, setError } = fuelSlice.actions;

export default fuelSlice.reducer;
